import BootstrapModal from "../../components/BootstrapModal";
import {Formik, Form, Field} from 'formik'
import TextField from "../../components/TextField";
import * as Yup from 'yup'
import PMSCheckBox from "../../components/PMSCheckBox";
import FormSelect from "../../components/FormSelect";
import {ProgressSpinner} from "primereact/progressspinner";
import { Hidden } from "@mui/material";

const RoleCompetencyRcaForm = ({modal, roleCompetencyRCAID,userRoleID,competencyID, 
weight,rca,active, isLoading,setactiveCompetencyTitleNames,setactiveUserRoleNames, onSubmit, onHide}) => {
    const validation = Yup.object({
        userRoleID:Yup.number().positive('please select role'),
        competencyID:  Yup.number().positive('please select competency'),        
		weight: Yup.number().positive('This field is Required'),
        rca: Yup.number().positive('This field is Required'),
    })
    return (<>
        <BootstrapModal headerText="Add Competency RCA" size={40} visible={modal} onHide={onHide}>
            <Formik
                validationSchema={validation}
                initialValues={{
                    roleCompetencyRCAID: roleCompetencyRCAID, 
                    competencyID: competencyID,
                    userRoleID:userRoleID,
                    weight: weight,
                    rca:rca,
                    active: active}}
                onSubmit={onSubmit}>
                {formik =>

                    (<>
                        <Form>
                            <Field type="hidden" name="roleCompetencyRCAID"/>                                                    
                            <FormSelect id="userRoleID" name="userRoleID" options={setactiveUserRoleNames}/>
                            <FormSelect id="competencyID" name="competencyID" options={setactiveCompetencyTitleNames}/>						                            
                            <TextField label={'Weight'} type="text" name="weight"/>
                            <TextField label={'RCA'} type="text" name="rca"/> 
                            <PMSCheckBox label={'Active'} name={'active'} id={'active'}/>
                            {isLoading ? <ProgressSpinner style={ {height:30,width:30} }/> : <button type="submit" className="btn btn-primary">{roleCompetencyRCAID === 0 ? 'Save' : 'Update'} </button>}

                        </Form>
                    </>)}

            </Formik>
        </BootstrapModal>
    </>)
}

export default RoleCompetencyRcaForm